/* cart-drawer.js: basket drawer. Commented source: research/2026-10-10-polish/src/BASKET/cart-drawer.src.js */
(function () {
var overlay = document.querySelector('[data-cd-overlay]');
var drawer = document.querySelector('[data-cart-drawer]');
if (!drawer || !overlay) return;
var body = drawer.querySelector('[data-cd-body]');
var foot = drawer.querySelector('[data-cd-foot]');
var subEl = drawer.querySelector('[data-cd-subtotal]');
var savEl = drawer.querySelector('[data-cd-savings]');
var discEl = drawer.querySelector('[data-cd-discounts]');
var progEl = drawer.querySelector('[data-cd-progress]');
// 2026-10-11 (offer switch, Jack 10 Oct): no site-wide discount; free delivery is the everyday offer. The €50/€100 tier maths, bar and "Unlocks" tags run only while the theme setting show_tier_promo is on (html data-tiers).
var TIERS = document.documentElement.getAttribute('data-tiers') === '1';
var fillEl = drawer.querySelector('[data-cd-fill]');
var recsEl = drawer.querySelector('[data-cd-recs]');
var errEl = drawer.querySelector('[data-cd-error]');
var liveEl = drawer.querySelector('[data-cd-live]');
function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
function clearError() { if (errEl) { errEl.hidden = true; errEl.textContent = ''; } }
var G = '#2e7d32';
var WIDE = '.cd[data-n=many] .cdr{display:grid;grid-template-columns:var(--cdr-ph,96px) minmax(0,1fr);grid-template-rows:1fr auto;column-gap:12px;row-gap:8px;align-items:start}.cd[data-n=many] .cdr__img{grid-column:1;grid-row:1;width:var(--cdr-ph,96px);height:var(--cdr-ph,96px);aspect-ratio:auto}.cd[data-n=many] .cdr__txt{grid-column:2;grid-row:1;padding:0;align-self:stretch}.cd[data-n=many] .cdr__title{min-height:0;padding:4px 0 22px;margin:-4px 0 -22px}.cd[data-n=many] .cdr__opt{-webkit-line-clamp:1}.cd[data-n=many] .cdr__add{grid-column:1/-1;grid-row:2}.cd[data-n=many] .cdr--sk .cdr-sk__l{grid-column:2;grid-row:1;margin-top:6px}.cd[data-n=many] .cdr--sk .cdr-sk__l--s{margin-top:30px}.cd[data-n=many] .cdr--sk::after{content:"";grid-column:1/-1;grid-row:2;height:44px;border-radius:8px;background:#eef0f3}';
var CSS = [
'.cd .cd__title{font-size:20px;line-height:1.25}',
'.cd .cd__scroll{display:flex;flex-direction:column}',
'.cd .cd__scroll>*{flex-shrink:0}',
'.cd .cd__scroll>.cd__progress .cart-progress__msg{font-size:14px;line-height:1.35}',
'.cd .cart-progress__fill{background:#a9853a}',
'.cd .cd__scroll>.cd__progress{margin:0;padding:12px 16px 2px}',
'.cd .cd__body{padding:0 16px}',
'.cdl{display:flex;gap:12px;padding:12px 0;border-bottom:1px solid var(--color-border)}',
'.cdl:last-child{border-bottom:0}',
'.cdl__img{flex:none;width:100px;height:100px;border-radius:8px;overflow:hidden;background:#f5f5f7}',
'.cdl__img img{width:100%;height:100%;object-fit:contain;display:block}',
'.cd[data-n=many] .cdl__img{width:76px;height:76px}',
'.cdl__info{flex:1;min-width:0;display:flex;flex-direction:column}',
'.cdl__title{display:block;padding:4px 0 22px;margin:-4px 0 -22px;font-size:16px;font-weight:600;line-height:1.3;color:var(--color-text)}',
'.cdl__title>span{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
'.cdl__title:hover{text-decoration:underline;text-underline-offset:2px}',
'.cdl__opt{font-size:14px;line-height:1.3;color:var(--color-muted);margin-top:2px}',
'.cdl__row{display:flex;align-items:center;gap:4px;margin-top:6px}',
'.cdl__qty{display:inline-flex;align-items:center;border:1px solid #858a94;border-radius:8px}',
'.cdl__qty button{width:44px;height:44px;border:0;background:none;font-size:20px;line-height:1;color:var(--color-text);cursor:pointer;touch-action:manipulation;border-radius:7px}',
'.cdl__qty button:active{background:var(--color-border)}',
'.cdl__qty span{min-width:22px;text-align:center;font-weight:700;font-size:16px}',
'.cdl__rm{flex:none;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;border:0;background:none;color:var(--color-muted);border-radius:8px;cursor:pointer;touch-action:manipulation}',
'.cdl__rm:hover,.cdl__rm:active{color:var(--color-text);background:var(--color-bg-muted)}',
'.cdl__price{margin-left:auto;display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;white-space:nowrap}',
'.cdl__now{font-weight:800;font-size:18px;color:var(--color-sale)}',
'.cdl__rrp{font-size:12px;color:var(--color-muted)}',
'.cdl__save{font-size:12px;font-weight:700;color:' + G + '}',
'.cdl__adding{font-size:14px;font-weight:700;color:var(--color-muted)}',
'.cdl.is-pending .cdl__qty,.cdl.is-pending .cdl__price,.cdl.is-pending .cdl__rm{opacity:.5}',
'.cd .cd-recs{margin-top:auto;border-top:0;background:#fff;padding:0 0 12px}',
'.cd .cd__scroll>.cd-recs:not(:empty){justify-content:flex-end}',
'.cd .cd-recs>:first-child{border-top:1px solid var(--color-border)}',
'.cdr-head{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;column-gap:8px;padding:12px 16px 8px}',
'.cdr-title{margin:0;font-family:inherit;font-size:16px;font-weight:800;line-height:1.3;color:var(--color-text);white-space:nowrap}',
'.cdr-note{font-size:14px;font-weight:700;line-height:1.3;color:' + G + ';white-space:nowrap}',
'.cdr-row{display:flex;gap:8px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-padding-left:16px;padding:0 16px 2px;scrollbar-width:none;overscroll-behavior-x:contain}',
'.cdr-row::-webkit-scrollbar{display:none}',
'.cdr{flex:0 0 calc((100% - 16px) / 2.25);min-width:0;display:flex;flex-direction:column;scroll-snap-align:start}',
'.cdr__img{position:relative;display:block;height:96px;border-radius:8px;overflow:hidden;background:#f5f5f7}',
'.cd[data-n=one] .cdr__img{height:auto;aspect-ratio:1/1}',
'.cdr__img img{width:100%;height:100%;object-fit:contain;display:block;mix-blend-mode:multiply}',
'.cdr__txt{flex:1 0 auto;display:flex;flex-direction:column;padding:6px 0 8px}',
'.cdr__title{display:block;padding:4px 0 22px;margin:-4px 0 -22px;font-size:14px;font-weight:600;line-height:1.3;color:var(--color-text)}',
'.cdr__buy{margin-top:auto;padding-top:2px;display:flex;flex-direction:column}.cdr__buy>.cdr__price{margin-top:0}',
'.cdr__title>span{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
'.cdr__title:hover{text-decoration:underline;text-underline-offset:2px}',
'.cdr__opt{font-size:12px;line-height:1.3;color:var(--color-muted);display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
'.cdr__price{margin-top:2px;font-size:16px;font-weight:800;line-height:1.25;color:var(--color-sale);white-space:nowrap}',
'.cdr__was{font-size:12px;line-height:1.3;color:var(--color-muted);white-space:nowrap}',
'.cdr__save,.cdr__unl{font-weight:700;color:' + G + '}',
'.cdr__unl{font-size:12px;line-height:1.3;white-space:nowrap}',
'.cdr__add{width:100%;min-height:44px;padding:0 6px;display:inline-flex;align-items:center;justify-content:center;gap:4px;border:1.5px solid var(--jshop-btn-primary,#0f766e);border-radius:8px;background:var(--jshop-btn-primary,#0f766e);color:#fff;font:inherit;font-size:14px;font-weight:700;line-height:1.1;white-space:nowrap;cursor:pointer;touch-action:manipulation}',
'.cdr__add:hover{background:var(--color-buy-dark,#115e59);border-color:var(--color-buy-dark,#115e59)}',
'.cdr__add:active{transform:translateY(1px)}',
'.cdr__add:focus-visible{outline:3px solid var(--color-buy-dark,#115e59);outline-offset:2px}',
'.cdr__add.is-busy{opacity:.7;cursor:progress}',
'.cdr__add.is-added,.cdr__add.is-added:hover{background:' + G + ';border-color:' + G + ';color:#fff;cursor:default}',
'.cdr--sk .cdr__img,.cdr-sk__l,.cdr-sk__t{background:#eef0f3}',
'.cdr-sk__t{height:14px;width:45%;margin:14px 16px 10px;border-radius:4px}',
'.cdr-sk__l{display:block;height:12px;width:90%;margin-top:8px;border-radius:4px}',
'.cdr-sk__l--s{width:50%}',
'.cd .cd__foot{padding:12px 16px 4px}',
'.cd .cd__discounts{margin:0 0 4px}',
'.cd .cd__sub,.cd .cd__disc{display:flex;justify-content:space-between;gap:12px;font-size:14px;line-height:1.4;margin:0 0 2px;white-space:nowrap}',
'.cd .cd__disc{font-weight:700;color:' + G + '}',
'.cd .cd__subtotal{align-items:baseline;font-size:18px;font-weight:800;line-height:1.3;margin:0 0 4px}',
'.cd .cd__subtotal .cd__savings{margin-left:8px;font-size:14px;font-weight:700;color:' + G + '}',
'.cd .cd__savings strong{font-weight:700}',
'.cd .cd__meta{margin:0 0 8px}',
'.cd .cd__meta .cd__delivery{font-size:14px;line-height:1.35}',
'.cd .cd__trust{margin:0;font-size:14px;line-height:1.35;text-align:left;white-space:nowrap;min-width:0}',
'.cd__end{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:44px}',
'@media (max-width:767px){.cd__trust-more{display:none}}',
'@media (max-width:389px){.cd__delivery .eta-getit{display:none}}',
'.cd .cd__foot .cd__go{width:100%;min-height:52px;margin:0 0 8px;font-size:16px;white-space:nowrap}',
'.cd__full{flex:none;display:flex;align-items:center;justify-content:center;min-height:44px;margin:0 -12px 0 0;padding:0 12px;font-size:14px;font-weight:600;line-height:1.2;color:var(--jshop-btn-secondary,#3d4253);text-decoration:underline;text-underline-offset:3px;white-space:nowrap;touch-action:manipulation}',
'.cd__full:hover{text-decoration-thickness:2px}',
'.cd .cd__wallets{--shopify-accelerated-checkout-button-block-size:44px;--shopify-accelerated-checkout-row-gap:8px;min-height:44px;margin-top:0}',
'.cd .cd__wallets .wallet-cart-grid--skeleton{min-height:44px}',
'.cd .cd__wallets .wallet-cart-button__skeleton{height:44px;background:transparent!important;animation:none!important}',
'@media (max-width:379px){.cdl__img{width:88px;height:88px}.cd[data-n=many] .cdl__img{width:72px;height:72px}}',
'@media (max-width:767px){.cd[data-n=many] .cdl__title{font-size:14px}.cd[data-n=many] .cdl{padding:8px 0}.cd[data-n=many] .cdr__img{height:72px}.cd[data-n=many] .cdr-head{padding-top:8px;padding-bottom:6px}}',
'@media (min-width:768px){.cd{width:540px}.cd .cd__scroll>.cd__progress{padding-left:20px;padding-right:20px}.cd .cd__body{padding:0 20px}.cdl__info{position:relative}.cdl__price{position:absolute;top:0;right:0}.cdl__title,.cdl__opt{padding-right:76px}.cdr-head{padding-left:20px;padding-right:20px}.cdr-row{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;overflow:visible;padding:0 20px 2px}.cdr{flex:none}.cdr:nth-child(n+4){display:none}.cdr__img{height:auto;aspect-ratio:1/1}.cd .cd__foot{padding-left:20px;padding-right:20px}}',
'@media (min-width:768px) and (max-height:820px){.cd .cd__meta{margin-bottom:6px}.cd[data-n=one] .cdr__txt{padding-bottom:4px}.cd[data-n=many] .cdl{padding:8px 0}.cd[data-n=many] .cdr__txt{padding-bottom:6px}}',
'@media (max-width:767px) and (max-height:800px){.cd[data-n=many] .cdr__img{height:56px}.cd[data-n=many] .cdr__txt{padding-bottom:6px}.cd[data-n=many] .cdl{padding:6px 0}.cd[data-n=many] .cdl__row{margin-top:2px}.cd[data-n=many] .cdr-head{padding-top:8px;padding-bottom:6px}.cd .cd__scroll>.cd__progress{padding-top:8px}.cd .cd__foot{padding-top:10px;padding-bottom:2px}.cd .cd__meta{margin-bottom:6px}.cd[data-n=one] .cdr__img{aspect-ratio:auto;height:120px}}',
// 2026-10-11 (Jack): on laptop screens the "Complete your ..." Add to Basket buttons sat under the basket total (1280x720, 1366x768).
// Shorter photos on short desktop windows keep the whole card, button included, above the total.
'@media (min-width:768px) and (max-height:900px){.cd[data-n=one] .cdr__img{aspect-ratio:auto;height:112px}}',
'@media (min-width:768px) and (max-height:780px){.cd[data-n=one] .cdr__img{height:92px}}',
'@media (max-width:767px){.cd[data-n=many] .cd-recs{--cdr-ph:96px;margin-top:0}.cd[data-n=many] .cd__scroll>.cd-recs:not(:empty){flex-grow:0;justify-content:flex-start}.cd[data-n=many] .cdr{flex:0 0 86%}' + WIDE + '}',
'@media (max-width:767px) and (max-height:700px){.cd[data-n=many] .cd-recs{--cdr-ph:80px}}',
'@media (min-width:768px) and (max-height:820px){.cd[data-n=many] .cd-recs{--cdr-ph:96px;margin-top:0}.cd[data-n=many] .cd__scroll>.cd-recs:not(:empty){flex-grow:0;justify-content:flex-start}.cd[data-n=many] .cdr-row{grid-template-columns:repeat(2,minmax(0,1fr))}.cd[data-n=many] .cdr:nth-child(n+3){display:none}' + WIDE + '}'
].join('');
if (!document.getElementById('cd-css')) { var st = document.createElement('style'); st.id = 'cd-css'; st.textContent = CSS; document.head.appendChild(st); }
var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
var moneyFmt, moneyFmt0;
try { moneyFmt = new Intl.NumberFormat('en-IE', { style: 'currency', currency: CUR }); moneyFmt0 = new Intl.NumberFormat('en-IE', { style: 'currency', currency: CUR, minimumFractionDigits: 0, maximumFractionDigits: 0 }); } catch (e) { moneyFmt = moneyFmt0 = null; }
var money = function (c) { c = Math.round(c); var whole = c % 100 === 0; if (moneyFmt) return (whole ? moneyFmt0 : moneyFmt).format(c / 100); return '€' + (whole ? String(c / 100) : (c / 100).toFixed(2)); };
var sized = function (u, w) { if (!u) return u; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u)) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; };
var BIN = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';
var SS = (function () { try { var t = window.sessionStorage; t.setItem('_jx', '1'); t.removeItem('_jx'); return t; } catch (e) { return null; } })();
function ssGet(k) { if (!SS) return null; try { var o = JSON.parse(SS.getItem(k) || 'null'); return o && (Date.now() - o.t < 30 * 60e3) ? o.v : null; } catch (e) { return null; } }
function ssSet(k, v) { if (!SS) return; try { SS.setItem(k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} }
function headerCount() { var c = document.querySelector('.header__cart-count'); return c ? (parseInt(c.textContent, 10) || 0) : -1; }
var shown = null;
function placeholder(msg) { body.innerHTML = '<p class="cd__empty">' + msg + '</p>'; foot.hidden = true; var pw = drawer.querySelector('.cd__progress'); if (pw) pw.style.display = 'none'; }
var walletsForm = drawer.querySelector('[data-cd-wallets]');
var walletsMounted = false;
function mountWallets() {
if (walletsMounted || !walletsForm) return;
if (shown && (shown.items || []).some(function (it) { return it.pending; })) { walletsForm.hidden = false; walletsForm.classList.add('is-waiting'); return; }
var tpl = walletsForm.querySelector('[data-cd-wallets-src]');
if (!tpl || !tpl.content) return;
walletsMounted = true;
walletsForm.appendChild(document.importNode(tpl.content, true));
tpl.parentNode.removeChild(tpl);
walletsForm.hidden = false; walletsForm.classList.remove('is-waiting');
warmWallets();
}
function warmWallets() {
try { if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') Shopify.PaymentButton.init(); } catch (e) {}
}
var warmed = false;
function preconnect() {
if (warmed || !walletsForm) return; warmed = true;
['https://www.paypal.com', 'https://www.paypalobjects.com', 'https://pay.google.com'].forEach(function (h) { var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; document.head.appendChild(l); });
}
if (walletsForm) {
document.addEventListener('pointerenter', function (e) {
if (walletsMounted || e.pointerType === 'touch') return;
if (!e.target || !e.target.closest || !e.target.closest('.header__cart')) return;
var c = document.querySelector('.header__cart-count');
if (!c || !(parseInt(c.textContent, 10) > 0)) return;
warmWallets(); preconnect();
}, true);
}
var lastFocus = null;
var pushed = false;
function focusables() { return [].filter.call(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; }); }
var cdTitle = drawer.querySelector('.cd__title');
function open() { clearError(); if (!foot.hidden) mountWallets(); lastFocus = document.activeElement; overlay.classList.add('is-open'); drawer.classList.add('is-open'); drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false'); var cb = drawer.querySelector('[data-cd-close]'); if (cb) cb.focus(); if (!pushed) { try { history.pushState({ cdOpen: true }, ''); pushed = true; } catch (e) {} } }
function teardown() { overlay.classList.remove('is-open'); drawer.classList.remove('is-open'); drawer.setAttribute('inert', ''); drawer.setAttribute('aria-hidden', 'true'); if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; } }
function close() { if (pushed) { history.back(); } else { teardown(); } }
window.addEventListener('popstate', function () { if (pushed) { pushed = false; if (drawer.classList.contains('is-open')) teardown(); } });
drawer.addEventListener('keydown', function (e) {
if (e.key !== 'Tab') return;
var f = focusables(); if (!f.length) return;
var first = f[0], last = f[f.length - 1];
if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
function updateCount(n) {
document.querySelectorAll('.header__cart-count').forEach(function (el) {
var prev = parseInt(el.textContent, 10) || 0;
el.textContent = n; el.style.display = n > 0 ? '' : 'none';
if (n > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
});
}
function announce(c) { if (liveEl && c && typeof c.item_count === 'number') liveEl.textContent = 'Basket updated: ' + c.item_count + (c.item_count === 1 ? ' item' : ' items') + ', total ' + money(c.total_price) + '.'; }
var rrpCache = ssGet('jx_rrp') || {}, rrpPending = {};
function rrpFor(it) {
var p = it.properties && (it.properties._rrp || it.properties._RRP);
if (p) return parseInt(p, 10) || 0;
return rrpCache[it.variant_id] || 0;
}
function fillRrp(cart) {
var need = cart.items.filter(function (it) {
var p = it.properties && (it.properties._rrp || it.properties._RRP);
return !p && !(it.variant_id in rrpCache) && it.handle && !rrpPending[it.handle];
});
if (!need.length) return;
Promise.all(need.map(function (it) {
rrpPending[it.handle] = true;
return fetch('/products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pr) {
(pr && pr.variants || []).forEach(function (v) { rrpCache[v.id] = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0; });
if (!(it.variant_id in rrpCache)) rrpCache[it.variant_id] = 0;
}).catch(function () { rrpCache[it.variant_id] = 0; });
})).then(function () { ssSet('jx_rrp', rrpCache); if (shown === cart) render(cart); });
}
var TIER = /€\s?(50|100)\s?off/i;
function discLabel(d) {
if (d.type === 'discount_code') return 'Code ' + (d.title || d.key || '');
var t = String(d.title || 'Discount'), i = t.indexOf(': ');
return (i > -1 && /off/i.test(t.slice(i + 2))) ? t.slice(i + 2) : t;
}
function estimate(base, fn) {
var c = JSON.parse(JSON.stringify(base || { items: [] }));
c.items = c.items || [];
fn(c);
c.items = c.items.filter(function (it) { return it.quantity > 0; });
var sum = 0, elig = 0, known = true, n = 0;
c.items.forEach(function (it) { n += it.quantity; if (it.final_line_price == null) { known = false; return; } sum += it.final_line_price; if (!it.gift_card) elig += it.final_line_price; });
var apps = (c.cart_level_discount_applications || []).filter(function (d) { return d.type === 'discount_code' || !(TIER.test(d.title || '') || d.title === 'Discount'); });
var off = 0; apps.forEach(function (d) { off += d.total_allocated_amount || 0; });
if (TIERS && known && CUR === 'EUR') { var t = elig >= 100000 ? 10000 : (elig >= 50000 ? 5000 : 0); if (t) { apps.push({ type: 'automatic', title: t === 10000 ? '€100 off €1,000' : '€50 off €500', total_allocated_amount: t }); off += t; } }
c.cart_level_discount_applications = apps;
c.item_count = n;
c.total_price = known ? Math.max(0, sum - off) : NaN;
return c;
}
function addLine(line) {
return function (c) {
var q = line.quantity || 1, add = line.price != null ? line.price * q : null, hit = null;
c.items.forEach(function (it) { if (!hit && it.variant_id === line.variant_id) hit = it; });
if (hit) { hit.quantity += q; hit.final_line_price = (add != null && hit.final_line_price != null) ? hit.final_line_price + add : null; hit.pending = true; }
else c.items.unshift({ key: 'pending', pending: true, variant_id: line.variant_id, quantity: q, product_title: line.title || '', variant_title: line.variant || '', image: line.image || '', url: line.url || '#', final_line_price: add, properties: line.rrp ? { _rrp: String(line.rrp) } : {} });
};
}
function normDisc(c) {
if (!c || !c.items) return c;
var apps = (c.cart_level_discount_applications || []).filter(function (d) { return d && typeof d.total_allocated_amount === 'number' && d.total_allocated_amount > 0; });
var sum = 0, have = 0;
c.items.forEach(function (it) { sum += it.final_line_price || 0; });
apps.forEach(function (d) { have += d.total_allocated_amount; });
var diff = isFinite(c.total_price) ? sum - c.total_price : 0;
if (diff > 0 && have !== diff) {
var by = {}, order = [], bs = 0;
c.items.forEach(function (it) { (it.discounts || []).forEach(function (x) { var t = x.title || 'Discount'; if (!(t in by)) { by[t] = 0; order.push(t); } by[t] += x.amount || 0; }); });
apps = order.map(function (t) { bs += by[t]; return { type: /^[A-Z0-9_-]+$/.test(t) ? 'discount_code' : 'automatic', title: t, total_allocated_amount: by[t] }; });
if (bs !== diff) apps = [{ type: 'automatic', title: 'Discount', total_allocated_amount: diff }];
}
c.cart_level_discount_applications = apps;
return c;
}
function render(cart, opt) {
var live = !opt;
normDisc(cart);
shown = cart;
if (live) ssSet('jx_cart', cart);
if (!cart.items || !cart.items.length) {
placeholder('Your basket is empty.'); if (recsEl) recsEl.innerHTML = ''; drawer.removeAttribute('data-n'); return;
}
foot.hidden = false;
drawer.setAttribute('data-n', cart.items.length > 1 ? 'many' : 'one');
if (drawer.classList.contains('is-open')) mountWallets();
var totalSaved = 0;
body.innerHTML = cart.items.map(function (it) {
var rrpC = rrpFor(it), known = it.final_line_price != null;
var lineRrp = rrpC * it.quantity;
var lineSave = (rrpC > 0 && known) ? (lineRrp - it.final_line_price) : 0;
if (lineSave > 0) totalSaved += lineSave; else lineSave = 0;
var price = !known ? '<span class="cdl__now cdl__adding">Adding…</span>'
: '<span class="cdl__now">' + money(it.final_line_price) + '</span>' + (lineSave > 0 ? '<s class="cdl__rrp"><span class="visually-hidden">was </span>RRP ' + money(lineRrp) + '</s><span class="cdl__save">Save ' + money(lineSave) + '</span>' : '');
var t = esc(it.product_title);
return '<div class="cdl' + (it.pending ? ' is-pending' : '') + '" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
'<a href="' + esc(it.url) + '" class="cdl__img" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="" width="100" height="100">' : '') + '</a>' +
'<div class="cdl__info">' +
'<a href="' + esc(it.url) + '" class="cdl__title"><span>' + t + '</span></a>' +
(it.variant_title ? '<div class="cdl__opt">' + optLine(it.variant_title) + '</div>' : '') +
'<div class="cdl__row">' +
'<div class="cdl__qty" role="group" aria-label="Quantity of ' + t + '">' +
'<button type="button" data-cd-dec aria-label="Decrease quantity of ' + t + '">−</button>' +
'<span data-cd-q>' + it.quantity + '</span>' +
'<button type="button" data-cd-inc aria-label="Increase quantity of ' + t + '">+</button>' +
'</div>' +
'<button type="button" class="cdl__rm" data-cd-remove aria-label="Remove ' + t + '">' + BIN + '</button>' +
'<div class="cdl__price">' + price + '</div>' +
'</div>' +
'</div>' +
'</div>';
}).join('');
(cart.cart_level_discount_applications || []).forEach(function (d) { totalSaved += (d.total_allocated_amount || 0); });
if (live) fillRrp(cart);
if (savEl) { if (totalSaved > 0) { savEl.hidden = false; savEl.innerHTML = 'You save <strong>' + money(totalSaved) + '</strong>'; } else { savEl.hidden = true; } }
var priceless = cart.items.some(function (it) { return it.final_line_price == null; });
subEl.textContent = (priceless || !isFinite(cart.total_price)) ? 'Adding…' : money(cart.total_price);
if (discEl) {
var dl = (cart.cart_level_discount_applications || []).filter(function (d) { return (d.total_allocated_amount || 0) > 0; });
var itemsSum = 0; cart.items.forEach(function (it) { itemsSum += (it.final_line_price || 0); });
discEl.innerHTML = dl.length ? '<div class="cd__sub"><span>Subtotal</span><span>' + (priceless ? '…' : money(itemsSum)) + '</span></div>' + dl.map(function (d) { return '<div class="cd__disc"><span>' + esc(discLabel(d)) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>'; }).join('') : '';
discEl.hidden = !dl.length;
}
if (window.jshopEpNudge) window.jshopEpNudge(cart, foot, live);
var t1 = 50000, t2 = 100000, m, pct;
var tot = 0; cart.items.forEach(function (it) { if (!it.gift_card) tot += (it.final_line_price || 0); });
var progWrap = drawer.querySelector('.cd__progress');
if (!TIERS || tot <= 0 || CUR !== 'EUR') {
if (progWrap) progWrap.style.display = 'none';
} else {
if (progWrap) progWrap.style.display = '';
pct = Math.min(100, Math.round(tot / t2 * 100));
if (tot >= t2) { m = "You've unlocked the full <strong>€100 off</strong>."; }
else if (tot >= t1) { m = '<strong>€50 off</strong> unlocked. <strong>' + money(t2 - tot) + '</strong> more for <strong>€100 off</strong>.'; }
else { m = 'Spend <strong>' + money(t1 - tot) + '</strong> more to save <strong>€50</strong>.'; }
progEl.innerHTML = m;
if (fillEl) fillEl.style.width = pct + '%';
}
loadRecs(cart, !live);
}
var recsAnchor = null;
var secP = null, secAt = 0;
var SEC_URL = '/cart?section_id=main-cart';
function fetchSection() { return fetch(SEC_URL, { headers: { 'Accept': 'text/html' } }).then(function (r) { if (!r.ok) throw r.status; return r.text(); }); }
function primeSection(p) { secP = p; secAt = Date.now(); if (p && p.catch) p.catch(function () {}); }
function sectionHtml() {
var p = (secP && Date.now() - secAt < 6000) ? secP : null; secP = null;
return p ? p.then(function (h) { return h || fetchSection(); }, fetchSection) : fetchSection();
}
function skeleton() {
if (!recsEl || recsEl.querySelector('.cdr')) return;
var card = '<div class="cdr cdr--sk"><span class="cdr__img"></span><span class="cdr-sk__l"></span><span class="cdr-sk__l cdr-sk__l--s"></span></div>';
recsEl.innerHTML = '<div aria-hidden="true"><div class="cdr-sk__t"></div><div class="cdr-row">' + card + card + card + '</div></div>';
}
function loadRecs(cart, noFetch) {
if (!recsEl || !cart.items.length) { if (recsEl) setRecs(''); recsAnchor = null; return; }
var sig = cart.items.map(function (it) { return it.key + 'x' + it.quantity; }).join(',') + '|' + cart.total_price;
if (recsAnchor === sig) return;
var rc = ssGet('jx_recs7');
if (rc && rc.sig === sig) { setRecs(rc.html); recsAnchor = sig; secP = null; return; }
if (noFetch) { if (!recsEl.innerHTML) skeleton(); return; }
recsAnchor = sig;
if (!recsEl.innerHTML) skeleton();
sectionHtml()
.then(function (html) {
if (recsAnchor !== sig) return;
var box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cx]');
var cards = box ? [].slice.call(box.querySelectorAll('[data-cx-item]')) : [];
if (!cards.length) { loadRelated(cart, sig); return; }
renderRecs(cards.slice(0, 4).map(function (c) {
var g = function (k) { return c.getAttribute('data-' + k) || ''; };
return { url: g('url'), title: g('full') || g('title'), name: g('title'), variant: g('variant'), featured_image: g('img'), price: parseInt(g('price'), 10) || 0, rrp: parseInt(g('rrp'), 10) || 0, unlock: g('unlock'), variants: [{ id: g('id'), available: true }] };
}), box.getAttribute('data-cx-title') || 'Complete your setup');
})
.catch(function () { if (recsAnchor === sig) loadRelated(cart, sig); });
}
function loadRelated(cart, sig0) {
var ids = [], inCart = {};
cart.items.forEach(function (it) { inCart[it.product_id] = true; if (ids.indexOf(it.product_id) < 0) ids.push(it.product_id); });
var anchorIds = ids.slice(0, 3);
var tot = cart.total_price || 0, tier = !TIERS ? 0 : (tot < 50000 ? 50000 : (tot < 100000 ? 100000 : 0));
var gap = tier ? tier - tot : 0, prize = !tier ? '' : (tier === 50000 ? '€50' : '€100');
if (!(gap > 0 && gap <= 25000)) gap = 0;
var stale = function () { return recsAnchor !== sig0; };
var rr = function (a, b, c) { if (!stale()) renderRecs(a, b, c); };
Promise.all(anchorIds.map(function (pid) {
return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
.then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }).catch(function () { return []; });
})).then(function (lists) {
if (stale()) return;
var score = {}, byId = {};
lists.forEach(function (products) {
products.forEach(function (p, i) {
if (inCart[p.id]) return;
byId[p.id] = p;
score[p.id] = (score[p.id] || 0) + (4 - i);
});
});
var ranked = Object.keys(byId).sort(function (a, b) { return score[b] - score[a]; }).map(function (id) { return byId[id]; });
var NOUNS = ['desk','chair','mattress','bed','rug','sofa','table','lamp','wardrobe','drawer','shelf','bookcase','stool','bench','rail','frame','ottoman'];
var PAIR = { desk: 'office-chairs', chair: 'desks', mattress: 'bed-frames', frame: 'mattresses', bed: 'mattresses', sofa: 'coffee-tables', table: 'rugs', rug: 'coffee-tables', wardrobe: 'chests-drawers', drawer: 'nightstands', shelf: 'storage-boxes', bookcase: 'office-chairs', stool: 'dining', bench: 'shoe-storage', rail: 'shoe-storage' };
var cartNouns = [];
cart.items.forEach(function (it) { var t = (it.product_title || it.title || '').toLowerCase(); NOUNS.forEach(function (n) { if (t.indexOf(n) > -1 && cartNouns.indexOf(n) < 0) cartNouns.push(n); }); });
var sameKind = function (p) { var t = (p.title || '').toLowerCase(); return cartNouns.some(function (n) { return t.indexOf(n) > -1; }); };
var pool = ranked.filter(function (p) { return !sameKind(p); });
var pickUnlock = function (list) { return list.filter(function (p) { return p.price >= gap && p.price >= 15900 && p.available !== false && !inCart[p.id]; }).sort(function (a, b) { return a.price - b.price; }); };
var pairCol = null; cartNouns.some(function (n) { if (PAIR[n]) { pairCol = PAIR[n]; return true; } return false; });
var fromPair = function () {
if (!pairCol) return Promise.resolve([]);
return fetch('/collections/' + pairCol + '/products.json?limit=24').then(function (r) { return r.json(); }).then(function (d) {
return (d.products || []).map(function (p) {
var v = (p.variants || []).filter(function (x) { return x.available; }).sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); })[0];
if (!v) return null;
return { id: p.id, title: p.title, url: '/products/' + p.handle, price: Math.round(parseFloat(v.price) * 100), rrp: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0, available: true, featured_image: (p.images && p.images[0] && p.images[0].src) || '', variants: [{ id: v.id, available: true }] };
}).filter(Boolean).filter(function (p) { return !sameKind(p); });
}).catch(function () { return []; });
};
if (gap) {
var u = pickUnlock(pool);
if (u.length) { rr(u.slice(0, 3), 'Add one to get ' + prize + ' off', prize); return; }
return fromPair().then(function (list) {
var u2 = pickUnlock(list);
if (u2.length) rr(u2.slice(0, 3), 'Add one to get ' + prize + ' off', prize);
else rr(pool.length ? pool.slice(0, 3) : list.slice(0, 3));
});
}
if (pool.length) { rr(pool.slice(0, 3)); return; }
return fromPair().then(function (list) { rr(list.slice(0, 3)); });
}).catch(function () { if (!stale()) setRecs(''); });
}
var recsHold = 0, recsLater = null;
function setRecs(html) {
var wait = recsHold - Date.now();
if (wait > 0) { recsLater = html; setTimeout(function () { if (recsLater !== null && Date.now() >= recsHold) { recsEl.innerHTML = recsLater; recsLater = null; fitSoon(); } }, wait + 20); return; }
recsLater = null; recsEl.innerHTML = html; fitSoon();
}
var fitRaf = 0;
function fitSoon() { if (fitRaf) return; fitRaf = requestAnimationFrame(function () { fitRaf = 0; fitRecs(); }); }
function fitRecs() {
if (!recsEl) return;
recsEl.style.removeProperty('--cdr-ph');
var card = recsEl.querySelector('.cdr:not(.cdr--sk)'), sc = recsEl.parentNode;
if (!card || !sc || !sc.clientHeight || getComputedStyle(card).display !== 'grid') return;
var base = parseFloat(getComputedStyle(recsEl).getPropertyValue('--cdr-ph')) || 96;
var img = card.querySelector('.cdr__img'), txt = card.querySelector('.cdr__txt');
if (!img || !txt) return;
var last = recsEl.lastElementChild; if (!last) return;
var spare = sc.getBoundingClientRect().top + sc.clientHeight - last.getBoundingClientRect().bottom - (parseFloat(getComputedStyle(recsEl).paddingBottom) || 0) - 16;
if (spare < 4) return;
var row = Math.max(img.offsetHeight, txt.offsetHeight);
var most = Math.min(160, card.clientWidth - 12 - 128);
var ph = Math.floor(Math.min(most, row + spare));
if (ph > base) recsEl.style.setProperty('--cdr-ph', ph + 'px');
}
if (window.ResizeObserver && recsEl) { try { var fitRo = new ResizeObserver(fitSoon); fitRo.observe(recsEl.parentNode); fitRo.observe(body); } catch (e) {} }
window.addEventListener('resize', fitSoon);
function renderRecs(products, title, prize) {
if (!products.length) { setRecs(''); ssSet('jx_recs7', { sig: recsAnchor, html: '' }); return; }
var unl = products.map(function (p) { return p.unlock || (prize && p.price >= 15900 ? prize : ''); });
var allUnl = unl.every(function (u) { return !!u; }) ? unl[0] : '';
var anyRrp = products.some(function (p) { return (p.rrp || p.compare_at_price || 0) > p.price; });
var anyUnl = !allUnl && unl.some(function (u) { return !!u; });
var blank = function (c) { return '<span class="' + c + '" aria-hidden="true">&nbsp;</span>'; };
var html = '<div class="cdr-head"><h3 class="cdr-title">' + esc(title || 'You might also like') + '</h3>' + (allUnl ? '<span class="cdr-note">Add one to save ' + esc(allUnl) + '</span>' : '') + '</div><div class="cdr-row">' + products.map(function (p, i) {
var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
if (!v) return '';
var unlock = unl[i];
var rrp = (p.rrp || p.compare_at_price || 0); if (!(rrp > p.price)) rrp = 0;
var full = p.title + (p.variant ? ', ' + p.variant : '');
var img = p.featured_image && (p.featured_image.src || p.featured_image);
return '<div class="cdr">' +
'<a href="' + esc(p.url) + '" class="cdr__img" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(sized(img, 300)) + '" alt="" width="150" height="150" loading="lazy">' : '') + '</a>' +
'<div class="cdr__txt">' +
'<a href="' + esc(p.url) + '" class="cdr__title" title="' + esc(full) + '"><span>' + esc(p.name || p.title) + '</span></a>' +
(p.variant ? '<span class="cdr__opt">' + optLine(p.variant) + '</span>' : '') +
'<span class="cdr__buy"><span class="cdr__price">' + money(p.price) + '</span>' +
(rrp ? '<span class="cdr__was"><s><span class="visually-hidden">was </span>RRP ' + money(rrp) + '</s> · <span class="cdr__save">Save ' + money(rrp - p.price) + '</span></span>' : (anyRrp ? blank('cdr__was') : '')) +
(unlock && !allUnl ? '<span class="cdr__unl">Unlocks ' + esc(unlock) + ' off</span>' : (anyUnl ? blank('cdr__unl') : '')) +
'</span></div>' +
'<button type="button" class="cdr__add" data-rec-add="' + esc(v.id) + '" data-rec-via="' + (unlock ? 'unlock' : 'drawer-pair') + '" data-title="' + esc(p.title) + '" data-variant="' + esc(p.variant || '') + '" data-img="' + esc(img || '') + '" data-url="' + esc(p.url) + '" data-price="' + p.price + '" data-rrp="' + rrp + '" aria-label="Add ' + esc(full) + ' to basket' + (unlock ? ', unlocks ' + esc(unlock) + ' off' : '') + '">Add to Basket</button>' +
'</div>';
}).join('') + '</div>';
setRecs(html);
ssSet('jx_recs7', { sig: recsAnchor, html: html });
}
var pre = null, preAt = 0;
function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
document.addEventListener('pointerdown', function (e) {
if (e.target && e.target.closest && e.target.closest('.header__cart')) { pre = fetchCart(); pre.catch(function () {}); preAt = Date.now(); if (headerCount() > 0) preconnect(); }
}, true);
function load(openAfter) {
var p = (pre && Date.now() - preAt < 3000) ? pre : fetchCart(); pre = null;
return p
.then(function (c) { render(c); updateCount(c.item_count); if (openAfter) open(); return c; })
.catch(function () { if (openAfter) window.location.href = '/cart'; });
}
function showNow() {
var n = headerCount();
if (shown && shown.item_count === n && !(shown.items || []).some(function (it) { return it.pending; })) return;
var c = ssGet('jx_cart');
if (c && c.item_count === n) render(c, { cached: true });
else if (n === 0) render({ items: [], item_count: 0, total_price: 0 }, { cached: true });
else placeholder('Loading your basket…');
}
function openPending(line) {
setTitle(true); preconnect();
var n = headerCount(), base = (shown && shown.item_count === n) ? shown : ssGet('jx_cart');
if (!(base && base.item_count === n) && n === 0) base = { items: [], item_count: 0, total_price: 0 };
if (base && base.item_count === n) render(estimate(base, addLine(line)), { pending: true });
else placeholder('Adding to your basket…');
open();
}
function change(key, qty) {
if (shown && shown.items && key !== 'pending') {
render(estimate(shown, function (c) {
c.items.forEach(function (it) {
if (it.key !== key) return;
var unit = (it.quantity && it.final_line_price != null) ? it.final_line_price / it.quantity : null;
it.quantity = qty; it.final_line_price = unit != null ? Math.round(unit * qty) : null; it.pending = true;
});
}), { pending: true });
}
return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
.then(function (r) { return r.json().then(function (c) { return { ok: r.ok, c: c }; }); })
.then(function (res) {
if (!res.ok || !res.c || typeof res.c.item_count !== 'number') {
var msg = (res.c && (res.c.description || res.c.message)) || 'Sorry, we couldn’t update that quantity.';
return load(false).then(function (c) { showError(msg); return c; });
}
clearError(); render(res.c); updateCount(res.c.item_count); announce(res.c); return res.c;
})
.catch(function (e) { load(false); throw e; });
}
overlay.addEventListener('click', close);
var cdClose = drawer.querySelector('[data-cd-close]');
if (cdClose) cdClose.addEventListener('click', close);
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
var busy = false;
body.addEventListener('click', function (e) {
var item = e.target.closest('.cdl'); if (!item || busy || item.classList.contains('is-pending')) return;
var key = item.getAttribute('data-key');
var q = parseInt(item.getAttribute('data-q'), 10) || 1;
var next = null;
if (e.target.closest('[data-cd-inc]')) next = q + 1;
else if (e.target.closest('[data-cd-dec]')) next = q - 1;
else if (e.target.closest('[data-cd-remove]')) next = 0;
if (next === null) return;
busy = true; change(key, next).then(function () { busy = false; }).catch(function () { busy = false; });
});
document.addEventListener('click', function (e) {
var a = e.target.closest('.header__cart');
if (a) { e.preventDefault(); if (cdTitle) cdTitle.textContent = 'Your basket'; showNow(); open(); load(false); }
});
if (recsEl) recsEl.addEventListener('click', function (e) {
var btn = e.target.closest('[data-rec-add]'); if (!btn || busy) return;
busy = true; btn.textContent = 'Adding…'; btn.classList.add('is-busy');
var id = parseInt(btn.getAttribute('data-rec-add'), 10), rrp = parseInt(btn.getAttribute('data-rrp'), 10) || 0;
var props = { _via: btn.getAttribute('data-rec-via') || 'drawer-pair' }; if (rrp) props._rrp = String(rrp);
if (shown && shown.items && !shown.items.some(function (it) { return it.pending; })) {
render(estimate(shown, addLine({ variant_id: id, quantity: 1, title: btn.getAttribute('data-title'), variant: btn.getAttribute('data-variant'), image: btn.getAttribute('data-img'), url: btn.getAttribute('data-url'), price: parseInt(btn.getAttribute('data-price'), 10) || null, rrp: rrp })), { pending: true });
}
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] }) })
.then(function (r) { if (!r.ok) throw r.status; return r.json(); })
.then(function () {
primeSection(fetchSection());
btn.classList.remove('is-busy'); btn.classList.add('is-added'); btn.disabled = true;
btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>Added';
recsHold = Date.now() + 1400; recsAnchor = null; return load(false);
})
.then(function (c) { busy = false; announce(c); })
.catch(function () { busy = false; btn.classList.remove('is-busy'); btn.textContent = 'Add to Basket'; load(false); showError('Sorry, that could not be added. Please try again.'); });
});
function setTitle(added) { if (cdTitle) cdTitle.textContent = added ? '✓ Added to your basket' : 'Your basket'; }
// 2026-10-12 prepublish (polish leftovers 2): option names as the product page shows them (same rules as
// window.jshopOptLabel in product.js and snippets/opt-label.liquid: "3 Drawers 70cm" -> "3 Drawers 70 cm"), each value of
// "A / B" on its own; the number and "cm" are joined by a no-break space so "cm" never wraps alone. Display only.
function optName(v) {
v = String(v == null ? '' : v);
var parts = v.split(' \u00b7 '), head = parts.shift().trim(), tail = parts.join(' \u00b7 ').trim();
var BED = { 'small single': '75 x 190 cm', 'single': '90 x 190 cm', 'small double': '120 x 190 cm', 'double': '135 x 190 cm', 'king': '150 x 200 cm', 'super king': '180 x 200 cm' };
if (head.indexOf("'") > -1 && head.indexOf('(') > -1) {
var name = head.split('(')[0].trim(), dim = BED[name.toLowerCase()];
if (dim) return name + ' ' + dim + (tail ? ' \u00b7 ' + tail.replace(/(\d)\s*cm\b/gi, '$1 cm') + ' deep' : '');
}
if (v.indexOf('" or "') > -1) { var pre = v.split('" or "')[0]; if (pre.indexOf('(') > -1) v = pre + ')'; }
var noImp = v.replace(/\(([^()]*)\)/g, function (m, inner) { return /\d['"]/.test(inner) ? '' : m; });
if (noImp !== v && /cm/i.test(noImp)) v = noImp.trim();
return v.replace(/(\d)\s?cm\b/gi, '$1 cm').replace(/ cm x /gi, ' x ').replace(/\s{2,}/g, ' ').trim();
}
function optLine(t) { return esc(String(t || '').split(' / ').map(optName).join(' / ')).replace(/(\d) cm\b/g, '$1\u00a0cm'); }
window.JSHOPCart = {
openWithCart: function (o) { setTitle(o && o.added); if (o && o.added) primeSection(fetchSection()); if (!drawer.classList.contains('is-open')) { showNow(); open(); } return load(false); },
openPending: openPending,
failPending: function () { var p = load(false); close(); return p; },
refresh: function () { return load(false); }
};
window.addEventListener('pageshow', function (e) { if (e.persisted) load(false); });
(window.requestIdleCallback || function (f) { setTimeout(f, 200); })(function () {
if (drawer.classList.contains('is-open')) return;
var n = headerCount(), c = ssGet('jx_cart');
if (n > 0 && !(c && c.item_count === n)) {
fetchCart().then(function (live) { if (!drawer.classList.contains('is-open')) { ssSet('jx_cart', live); render(live, { cached: true }); } }).catch(function () {});
} else showNow();
});
})();
